<ng-container *appI18nScopeReady>
  @if (this.dashboards.length === 0 && !loading()) {
    <p>{{ 'no_dashboard_created' | i18n }}</p>
  }
</ng-container>

